import axios from 'axios';
import { axiosETAGCache } from 'axios-etag-cache';

const axiosWithETAGCache = axiosETAGCache(axios);

const api = {
  async getAgentReportMetric() {
    const response = await axiosWithETAGCache.get(`/agent_report_metrics`);
    return response.data;
  },

  async updateAgentReportMetric(agentReportMetric) {
    const response = await axios.put(
      `/agent_report_metrics/${agentReportMetric.id}`,
      agentReportMetric
    );
    return response.data;
  },

  async getVoiceAgentReportMetric(payload) {
    const response = await axiosWithETAGCache.post(
      `/agent_report_analytics/voice`,
      payload
    );
    return response.data;
  },

  async getTextAgentReportMetric(payload) {
    const response = await axiosWithETAGCache.post(
      `/agent_report_analytics/text`,
      payload
    );
    return response.data;
  },

  async getMultichannelAgentReportMetric(payload) {
    const response = await axiosWithETAGCache.post(
      `/agent_report_analytics/multichannel`,
      payload
    );
    return response.data;
  },
};

export default api;
